import { forwardRef } from '@chakra-ui/react';
import { SelectField } from './SelectField';
import { MONTHS } from '../../constants';

export const SelectMonth = forwardRef(({ ...rest }, ref) => (
  <SelectField {...rest} options={MONTHS} inputRef={ref} />
));
